import { render, staticRenderFns } from "./KufangchukuByIdForm.vue?vue&type=template&id=55dfb4b9&scoped=true&"
import script from "./KufangchukuByIdForm.vue?vue&type=script&lang=js&"
export * from "./KufangchukuByIdForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dfb4b9",
  null
  
)

export default component.exports